export class IconTranslator {

  static commands: object = {
    sideMenu: {
      LOGOFF: 'exit',
      CMD_PPINIT: 'calculator',
      CMD_ACCEPT_VOUCHER: 'pricetags',
      TOT_DISC: 'cash',
      RETURN: 'undo',
      SUSPEND: 'play-skip-forward-circle',
      CHANGE_PASSWORD: 'lock',
      VOID_ALL: 'trash',
      PRINTLAST: 'print',
      CMD_INVOICE: 'document',
      CASH_PICKUP: 'file-tray-full',
      CASH_CLOSING_D: 'checkmark-done',
      CMD_HIDDEN: 'eye-off',
      PAUSE: 'pause',
      MAILRCPT: 'mail',
      'TOGGLE-FULL-SCREEN': 'expand',
      ORDERRECALL: 'document',
      CMD_SS_RECALL: 'barcode',
      CASH_COUNT: 'cash',
      CASH_LOAN: 'cash',
      TRANSF_TENDER: 'card',
      PAID_IN: 'arrow-back',
      PAID_OUT: 'arrow-forward',
      'Z-READ': 'glasses',
    }
  };

  constructor() { }

  static iconForDepartment(deptId: number) {
    switch (deptId) {
      case 1:
        return 'fas fa-apple-alt';
      case 2:
        return 'fas fa-drumstick-bite';
      case 3:
        return 'fas fa-egg';
      case 4:
        return 'fas fa-bread-slice';
      case 5:
        return 'fas fa-fish';
      default:
        return 'fas fa-ellipsis-h';
    }
  }
}
